var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0043 17.9644H11.5043V16.9644H16.0043C16.5463 16.9644 17.0043 16.4608 17.0043 15.8644V4.06436C17.0043 3.46796 16.5463 2.96436 16.0043 2.96436H11.5043V1.96436H16.0043C17.1071 1.96436 18.0043 2.90636 18.0043 4.06436V15.8644C18.0043 17.0224 17.1071 17.9644 16.0043 17.9644ZM11.8579 13.418L11.1507 12.7108L13.2971 10.5644H1.9043V9.56436H13.2971L11.1507 7.41796L11.8579 6.71076L15.2115 10.0644L11.8579 13.418Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon-login.131d87cc9470a3e5ca6bb157ac00d9d0.svg";
export { ForwardRef as ReactComponent };